import ContentsTypes from "@shared/enums/contentsTypes";
import PresentationBlockPreview from "@project/components/PresentationBlock/PresentationBlockPreview";
import ContentsCustomTypes from "@project/enums/contentsCustomTypes.enum";
export const HorizontalInfosItem = {
    label: "Ensemble d'informations",
    key: "items",
    type: ContentsCustomTypes.HORIZONTAL_INFO_ITEM,
    children: [
        {
            label: "Titre",
            key: "title",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Sous titre",
            key: "subtitle",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Description",
            key: "description",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Couleur",
            key: "color",
            type: ContentsTypes.COLOR,
            value: "#0CFFC6",
        },
    ],
};
export const HorizontalInfos = {
    label: "Bloc d'informations horizontales",
    type: ContentsCustomTypes.HORIZONTAL_INFOS,
    Preview: PresentationBlockPreview,
    icon: "grip-lines",
    editionModal: true,
    editionModalPosition: "top",
    children: [
        {
            key: "dynamicList",
            type: ContentsTypes.DYNAMIC_LIST,
            value: "",
            children: [
                {
                    key: "contentType",
                    children: [HorizontalInfosItem],
                    value: ContentsCustomTypes.HORIZONTAL_INFO_ITEM,
                },
            ],
        },
    ],
};
